// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".docking-panel.explode-submenu {\n  width: 400px !important;\n  height: 60px !important;\n}\n.docking-panel.explode-submenu input {\n  height: 45px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
